<template>
  <div class="app-main">
    <div class="content-tool">
      <div>
        <div class="content-tool--nav">
          <div class="content-tool--title fl">身份证号</div>
          <el-input placeholder="请输入身份证号" icon="search" v-model.trim="cardid" maxlength="18" @keyup.enter.native="fetchUsers" class="content-tool--input fl"></el-input>
        </div>
        <div class="content-tool--nav">
          <div class="content-tool--title fl">姓名</div>
          <el-input placeholder="请输入姓名" icon="search" v-model.trim="userName" @keyup.enter.native="fetchUsers" class="content-tool--input fl"></el-input>
        </div>
        <div class="content-tool--nav">
          <div class="content-tool--title fl">签约状态</div>
          <el-select v-model="ustatus" placeholder="请选择">
            <el-option v-for="item in signStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div style="margin: 30px 0 0 0;">
        <div class="content-tool--nav" style="width: 100px;">
          <el-button type="primary" class="content-tool--qry el-button-reset" @click="fetchUsers">查询</el-button>
        </div>
        <div class="content-tool--nav" style="width: 100px;">
          <el-button class="content-tool--reset el-button-reset" @click="reset">清空</el-button>
        </div>
      </div>
    </div>
    <div class="content-table">
      <!-- <el-table :data="users" size='medium' @row-click="fetchRowDetail" tooltip-effect="dark" :highlight-current-row="true"> -->
      <el-table :data="users" size='medium' tooltip-effect="dark" :highlight-current-row="true">
        <el-table-column prop="uid" label="服务平台ID" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ucardid" label="身份证号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="uname" label="姓名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="uphone" label="客户联系电话"></el-table-column>
        <!-- <el-table-column prop="ustatus" label="签约状态"></el-table-column> -->
        <el-table-column prop="uprovider" label="从业平台"></el-table-column>
        <!-- <el-table-column prop="uprovider" label="服务商"></el-table-column> -->
        <!-- <el-table-column prop="utime" label="最近发放日期"></el-table-column> -->
        <el-table-column prop="status" label="详情" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="fetchRowDetail(scope.row)">跳转详情</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="业务承揽协议" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="downloadPdf(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage"
        :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
// import { Loading } from 'element-ui';
// import { parseTime } from '@/utils';

export default {
  name: 'appmain',
  data() {
    return {
      users: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      options: [{
        value: 2,
        label: '全部',
      }],
      ustatus: '',
      cardid: '',
      userName: '',
      signStatus: [{
        value: 2,
        label: '全部',
      }, {
        value: 0,
        label: '未签约',
      }, {
        value: 1,
        label: '已签约',
      }],
    };
  },
  mounted() {
    // this.$store.commit('setPagestatus', 1);
    this.reset();
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      this.users = [];
      api.fetchUsers({
        params: {
          params: {
            userName: this.userName,
            cardid: this.cardid,
            ustatus: this.ustatus,
            index: this.currentPage - 1,
            size: this.pageSize,
          },
        },
      }).then((res) => {
        this.total = 0;
        if (!res) {
          return;
        }
        this.users = res.data;
        this.total = res.count;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    fetchRowDetail(row) {
      console.log(row);
      const params = {
        usidcard: row.ucardid,
      };
      this.$router.push({ path: 'userdetail', query: params });
    },
    downloadPdf(row) {
      // eslint-disable-next-line
      window.location = row.contractUrl;
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchUsers();
    },
    reset() {
      this.ustatus = 2;
      this.cardid = '';
      this.userName = '';
    },
  },
};
</script>

<style lang="less" scoped>

/*
@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 1200px;
  }
}
*/

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-tool {
  padding: 20px 17px 20px 20px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: 220px;
      height: 36px;
    }
  }
  .content-tool--operate {
    padding-right: 20px;
  }
}
.content-search-title {
  padding: 20px 0 0 0;
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 10px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
}

.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-table tbody tr:hover {
  color: red;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/usermanage.vue